export function withSandboxWorkspace(endpoint: string, escritorioId?: string): string {
  // Rotas admin não recebem o workspace global; a simulação mantém seu próprio escritório.
  if (!escritorioId) return endpoint;
  const separator = endpoint.includes('?') ? '&' : '?';
  return `${endpoint}${separator}workspaceId=${encodeURIComponent(escritorioId)}`;
}
